import { Switch, Tooltip } from '@mui/material';
import { useEntityMgr } from '../entityView/EntityMgrContext';
import { EntityFormMode } from '../enumerations/EntityFormMode';


export const HistToggle = () => {

  const { hist, toggleHist, entityFormMode } = useEntityMgr();

  return (
    <Tooltip title={'History'}>
      <Switch
        data-test-id="hist-toggle"
        disabled={entityFormMode !== EntityFormMode.VIEW}
        checked={hist}
        onChange={() => toggleHist()}
      />
    </Tooltip>
  )

}